<template>
  <div>
    <!-- Cabeçalho -->
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h5 class="mb-0">Tipos de Pagamento</h5>
      <b-button
        v-if="hasPermission('adicionar_parametros_tipos')"
        variant="primary"
        class="d-flex align-items-center"
        @click="irParaCadastro"
      >
        <i class="bi bi-plus-circle-fill mr-2" title="Novo Cadastro"></i>
      </b-button>
    </div>
  
    <!-- Filtros -->
    <div class="d-flex mb-3 gap-3">
      <input
        v-model="filters.tipo"
        placeholder="Filtrar por tipo"
        class="form-control"
        @input="filtrarTipos"
      />
      <b-button
        variant="secondary"
        @click="limparFiltros"
        class="d-flex align-items-center justify-content-center"
      >
        <i class="bi bi-funnel mr-2" title="Limpar Filtro"></i>
      </b-button>
    </div>
  
    <!-- Tabela -->
    <b-table
      :items="tipos"
      :fields="fields"
      striped
      hover
      @sort-changed="onSortChanged"
    >
      <template #cell(criado_em)="row">
        {{ formatDate(row.item.criado_em) }}
      </template>
      <template #cell(atualizado_em)="row">
        {{ formatDate(row.item.atualizado_em) }}
      </template>
      <!-- Exibir nomes dos relacionamentos -->
      <template #cell(nome_operador)="row">
        {{ row.item.nome_operador || 'Não informado' }}
      </template>
      <template #cell(nome_meio)="row">
        {{ row.item.nome_meio || 'Não informado' }}
      </template>
      <template #cell(nome_forma)="row">
        {{ row.item.nome_forma || 'Não informado' }}
      </template>
      <template #cell(tipo)="row">
        {{ row.item.tipo || 'Não informado' }}
      </template>
      <template #cell(actions)="row">
        <div class="text-end">
          <i
            v-if="hasPermission('detalhar_parametros_tipos')"
            class="bi bi-eye-fill text-primary mx-2"
            title="Detalhar"
            @click="detalharTipo(row.item.id)"
          ></i>
          <i
            v-if="hasPermission('alterar_parametros_tipos')"
            class="bi bi-pencil-fill text-warning mx-2"
            title="Editar"
            @click="editarTipo(row.item.id)"
          ></i>
          <i
            v-if="hasPermission('excluir_parametros_tipos')"
            class="bi bi-trash-fill text-danger mx-2"
            title="Excluir"
            @click="excluirTipo(row.item.id)"
          ></i>
        </div>
      </template>
    </b-table>
  
    <!-- Paginação -->
    <div class="d-flex justify-content-center align-items-center mt-3 gap-3">
      <b-button
        @click="paginaAnterior"
        :disabled="paginaAtual === 1"
        variant="light"
        class="p-1 d-flex align-items-center"
      >
        <i class="bi bi-chevron-left"></i>
      </b-button>
      <span>Página {{ paginaAtual }} de {{ totalPaginas }}</span>
      <b-button
        @click="proximaPagina"
        :disabled="paginaAtual >= totalPaginas"
        variant="light"
        class="p-1 d-flex align-items-center"
      >
        <i class="bi bi-chevron-right"></i>
      </b-button>
      <select
        v-model="limitePorPagina"
        @change="alterarLimite"
        class="form-select form-select-sm"
        style="width: 10%;"
      >
        <option value="10">10 registros</option>
        <option value="15">15 registros</option>
        <option value="20">20 registros</option>
      </select>
    </div>
  </div>
</template>
  
<script>
import axios from "@/services/axios";
import { BButton, BTable } from "bootstrap-vue-next";
  
export default {
  components: { BButton, BTable },
  data() {
    return {
      tipos: [],
      fields: [
        { key: "nome_operador", label: "Operador", sortable: true },
        { key: "nome_meio", label: "Meio", sortable: true },
        { key: "nome_forma", label: "Forma", sortable: true },
        { key: "tipo", label: "Tipo", sortable: true },
        { key: "criado_em", label: "Criado", sortable: true },
        { key: "atualizado_em", label: "Atualizado", sortable: true },
        { key: "actions", label: "Ações", class: "text-end" },
      ],
      filters: { tipo: "" },
      paginaAtual: 1,
      limitePorPagina: 10,
      totalPaginas: 1,
      currentSort: { key: "tipo", order: "asc" },
    };
  },
  methods: {
    async carregarTipos() {
      try {
        const response = await axios.get('/financeiro/parametros/tipos', {
          params: {
            page: this.paginaAtual,
            limit: this.limitePorPagina,
            tipo: this.filters.tipo || undefined,
            sortBy: this.currentSort.key,
            order: this.currentSort.order,
          },
        });
        this.tipos = response.data.data;
        this.totalPaginas = response.data.totalPages;
      } catch (error) {
        console.error('Erro ao carregar tipos:', error.message);
      }
    },
    formatDate(data) {
      if (!data) return "Não informado";
      return new Date(data).toLocaleString();
    },
    alterarLimite() {
      this.paginaAtual = 1;
      this.carregarTipos();
    },
    filtrarTipos() {
      this.paginaAtual = 1;
      this.carregarTipos();
    },
    async excluirTipo(id) {
      // Exibe o modal de confirmação customizado e aguarda a resposta do usuário
      const confirmou = await this.$confirm(
        "Tem certeza que deseja excluir este tipo?",
        "Confirmação"
      );

      if (confirmou) {
        try {
          await axios.delete(`/financeiro/parametros/tipos/${id}`, {
            validateStatus: function (status) {
              return status >= 200 && status < 300; // Apenas status 2xx serão considerados sucesso
            }
          });

          // Atualiza a listagem após a exclusão bem-sucedida
          this.carregarTipos();
          this.$toast.success("Tipo excluído com sucesso!");
        } catch (error) {
          console.error("Erro ao excluir tipo:", error);

          let mensagem = "Erro inesperado ao excluir tipo.";
          if (error.response && error.response.data) {
            mensagem = error.response.data.error || "Erro ao excluir tipo.";
          }
          
          // Exibe o alerta customizado com a mensagem de erro
          await this.$alert(mensagem, "Não permitido");
        }
      }
    },
    onSortChanged(ctx) {
      this.currentSort.key = ctx.sortBy;
      this.currentSort.order = ctx.sortDesc ? 'desc' : 'asc';
      this.carregarTipos();
    },
    paginaAnterior() {
      if (this.paginaAtual > 1) {
        this.paginaAtual--;
        this.carregarTipos();
      }
    },
    proximaPagina() {
      if (this.paginaAtual < this.totalPaginas) {
        this.paginaAtual++;
        this.carregarTipos();
      }
    },
    limparFiltros() {
      this.filters.tipo = '';
      this.paginaAtual = 1;
      this.carregarTipos();
    },
    irParaCadastro() {
      this.$router.push('/financeiro/parametros/tipos/novo');
    },
    editarTipo(id) {
      this.$router.push(`/financeiro/parametros/tipos/${id}`);
    },
    detalharTipo(id) {
      this.$router.push(`/financeiro/parametros/tipos/${id}/detalhar`);
    },
  },
  async mounted() {
    await this.fetchPermissions();
    this.carregarTipos();
  },
};
</script>
